module.exports = "/packs/images/products/pods-staged/J1T1810-tablet-c6a3a6a1e6e74cbcbad82b0501840765.jpg";


//////////////////
// WEBPACK FOOTER
// ./app/javascript/images/products/pods-staged/J1T1810-tablet.jpg
// module id = 1802
// module chunks = 0